import { useEffect } from 'react';

/** El mismo atributo que `react-remove-scroll-bar`: la regla que bloquea el scroll está en app.css. */
const LOCK = 'data-scroll-locked';

const count = () => {
  const value = Number.parseInt(document.body.getAttribute(LOCK) ?? '0', 10);
  return Number.isFinite(value) ? value : 0;
};

/**
 * Reemplaza a `RemoveScrollBar` de `react-remove-scroll-bar` (alias en vite.config.ts), que usan
 * los modales de Radix. La original inyecta un `<style>` con el bloqueo, y la CSP sin
 * `'unsafe-inline'` lo rechaza (decisión 60, ADR-106). Esta solo cuenta los modales abiertos en
 * el atributo del body, como la original.
 */
export function RemoveScrollBar(): null {
  useEffect(() => {
    document.body.setAttribute(LOCK, String(count() + 1));
    return () => {
      const next = count() - 1;
      if (next <= 0) document.body.removeAttribute(LOCK);
      else document.body.setAttribute(LOCK, String(next));
    };
  }, []);
  return null;
}
